import Info from 'components/shared/Info'
import { darkMode } from 'styles/theme'
import Icon from 'components/shared/Icon'
import { useCopyToClipboard } from 'utils/hooks/useCopyToClipboard'
import {
    SummarySaleCodeBox,
    SummarySaleCodeButton,
    SummarySaleCodeContent,
} from './styles'
import { PromotionCodeBox } from 'components/global/promotions/PromotionCodeBox'
import Link from 'components/shared/Link'
import { BLACK_WEEKEND_REGULATIONS_LINK } from 'constants/links'
import Box from 'components/shared/Box'
import { FormattedMessage } from 'react-intl'

const SummarySalePromotionCode = () => {
    const TEXT_TO_CLIPBOARD = 'BLACKWEEKEND'
    const { handleCopyToClipboard, isCopied } = useCopyToClipboard()

    return (
        <SummarySaleCodeBox isFullWidth mb={24} align="center">
            <Info
                color="info"
                hasNoBackground
                hasBorder
                theme={darkMode}
                align={['flex-start', 'center']}
                isFullWidthContent
            >
                <Box
                    direction={['column', 'row']}
                    justify="space-between"
                    align={['flex-start', 'center']}
                    gap={8}
                >
                    <SummarySaleCodeContent
                        isFullWidth
                        direction="row"
                        align="center"
                        justify={['space-between', 'flex-start']}
                        gap={[16, 8]}
                    >
                        <PromotionCodeBox isCopied={isCopied}>
                            <SummarySaleCodeButton
                                onClick={() =>
                                    handleCopyToClipboard(TEXT_TO_CLIPBOARD)
                                }
                            >
                                <Icon variant="copy" />
                            </SummarySaleCodeButton>
                        </PromotionCodeBox>
                    </SummarySaleCodeContent>
                    <Link
                        icon={null}
                        variant="secondary"
                        textVariant="bodySmallStrong"
                        path={BLACK_WEEKEND_REGULATIONS_LINK}
                        target="_blank"
                    >
                        <FormattedMessage
                            id="promo.black_weekend.regulations_link"
                            defaultMessage="Regulamin promocji"
                        />
                    </Link>
                </Box>
            </Info>
        </SummarySaleCodeBox>
    )
}

export default SummarySalePromotionCode
